import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./MainLog.css";
import { useEffect, useState, useRef } from "react";
import Card from "../../components/Card";
import InnerHeader from "../../components/InnerHeader";
import MultiDropdown from "../../components/MultiDropdown";
import Dropdown from "../../components/Dropdown";
import { FaCloudDownloadAlt } from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import {
  startOfMonth,
  endOfMonth,
  format,
  addDays,
  subMonths,
  addMonths,
  startOfToday,
  startOfYesterday,
  startOfWeek,
  endOfWeek,
  subWeeks
} from "date-fns";
import { FaFilter } from "react-icons/fa";
import SidePopup from "../../components/Popup/SidePopup";
import SingleDropdown from "../../components/SingleDropdown";
import DynamicTooltip from "../../components/DynamicTooltip";
import PayDue from "../../assets/pay_due.svg";
import constant from "../../constant/constant";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { logout } from "../../store/authSlice";
import Popup from "../../components/Popup/Popup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const dummyLogs = {
  1: [
    {
      id: 1,
      date: "01 OCT 2019",
      drone_id:"UIN12345678",
      trainer: "Amit Lal Drone",
      student: "Rohit Lal Drone",
      rpto: "ABC RPTO",
      startTime: "10:00",
      endTime: "11:00",
      duration: "1 hr",
      remarks: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      class:"SM",
      full_class:"Small",
      category:"R",
      full_category:"Rotorcraft",
      rotoarcraft_dual:"00:30",
      rotoarcraft_rpic:"--",
      aeroplane_dual:"--",
      aeroplane_rpic:"--",
      other_dual:"--",
      other_rpic:"--",
      basic:"00:30",
      speical:"--",
      advanced:"--",
      night: "--",
      instructional_hours: "--",
    },
  ],
  2: [
    {
      id: 2,
      date: "01 OCT 2019",
      drone_id:"UIN87654321",
      trainer: "Suman Chourdhary",
      student: "Avi Saxsena",
      rpto: "XYZ RPTO",
      startTime: "2:00",
      endTime: "4:00",
      duration: "2 hrs",
      remarks: "Clear sky",
      class:"ME",
      full_class:"MEDIUM",
      category:"A",
      full_category:"Aeroplane",
      rotoarcraft_dual:"--",
      rotoarcraft_rpic:"00:30",
      aeroplane_dual:"--",
      aeroplane_rpic:"--",
      other_dual:"--",
      other_rpic:"--",
      basic:"00:30",
      speical:"--",
      advanced:"--",
      night: "--",
      instructional_hours: "--",
    },
  ],
};

// const dummyLogs = {};
const MainLog = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth);
  const dispatch  = useDispatch();
  const UserID = user.userid;

  const dateRangePickerRef = useRef(null);
  const [logs, setLogs] = useState([]);
  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedDrone, setSelectedDrone] = useState([]);
  const [showDateRangeCalendar, setShowDateRangeCalendar] = useState(false);
  const [showDateRangePicker, setShowDateRangePicker] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedRotarcraft, setSelectedRotarcraft] = useState({});
  const [dateRangeValue, setDateRangeValue] = useState([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 0),
      key: "selection",
    },
  ]);
  
  var oldFilter = {};
  const [selectedTab, setSelectedTab] = useState("student_crm_log");
  const [studentDateOption, setStudentDateOption] = useState("");
  const [studentDateOptionLabel, setStudentDateOptionLabel] = useState("Select Date");
  const [dateTimeType, setDateTimeType] = useState("");
  const [showDateInput, setShowDateInput] = useState(false);
  const [studentDateListOptions, setStudentDateListOptions] = useState([]);
  const limit = 50;
  const [recordList, setRecordList] = useState([]);
  const [allApiFilter, setAllApiFilter] = useState([]);
  const [totalPageNum, setTotalPageNum] = useState(0);
  const [allApidata, setAllApiData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [autoLoader, setAutoLoader] = useState(false);
  const [displayMsg, setDisplayMsg] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [filterApiStatus, setFilterApiStatus] = useState(false);
  const [listFilter, setListFilter] = useState({});
  const [filterApplyStatus, setFilterApplyStatus] = useState(false);
  const [filterStatus, setFilterStatus] = useState(0);
  const [filterCount, setFilterCount] = useState(0);
  const [categoryListOptions, setCategoryListOptions] = useState([]);
  const [classListOptions, setClassListOptions] = useState([]);
  const [dataStatus, setDataStatus] = useState(false);
  const [checkWorkOrderStatus, setCheckWorkOrderStatus] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [totalFlyingCount, setTotalFlyingCount] = useState("00:00");
  const [showDroneLogMontlyData, setShowLogMontlyData] = useState(false);
  const [showCalendarData, setShowCalendarData] = useState([]);
  const [logSelectedMonth, setLogSelectedMonth] = useState({});
  const [updateBtnStatus, setUpdateBtnStatus] = useState(false);
  
  
  // const categoryListOptions = [
  //   { value: "A", label: "Aeroplane - A" },
  //   { value: "R", label: "Rotorcraft - R" },
  //   { value: "H", label: "Hybrid - H" },
  //   { value: "O", label: "Other - O" },
  // ];
  // const classListOptions = [
  //   { value: "N", label: "Nano" },
  //   { value: "Mi", label: "Micro" },
  //   { value: "Sm", label: "Small" },
  //   { value: "Me", label: "Medium" },
  //   { value: "LA", label: "Large" },
  // ];

  const handleStudentDateOptionChange = (option) => {
    setStudentDateOption(option.value);
    setStudentDateOptionLabel(option.label);
    if (option.value) {
      setShowDateRangePicker(true);
      setShowDateInput(true);
    } else {
      setShowDateRangePicker(false);
      setShowDateInput(false);
    }
  }



  const handleSelectClass = (value) => {
    const index = selectedClass.indexOf(value);
    if (index === -1) {
      setSelectedClass([...selectedClass, value]);
    } else {
      const updatedValues = [...selectedClass];
      updatedValues.splice(index, 1);
      setSelectedClass(updatedValues);
    }
  };
  const handleSelectCategory = (value) => {
    const index = selectedCategory.indexOf(value);
    if (index === -1) {
      setSelectedCategory([...selectedCategory, value]);
    } else {
      const updatedValues = [...selectedCategory];
      updatedValues.splice(index, 1);
      setSelectedCategory(updatedValues);
    }
  };
  const handleFilterClick = () => {
    setShowFilterPopup(true);
  };
  const closeFilter = () => {
    setShowFilterPopup(false);
    document.body.style.overflow = "auto";
  };
  const initial_obj = {
    page_type: selectedTab,
    log_id: user.userid,
    dateOptionsselect:"",
    selectedCategory:[],
    selectedClass:[],
    dateRangeValue:{
      startDate: new Date(),
      endDate: addDays(new Date(), 0),
      key: "selection",
    },
    dateRangeValuefilter: "",
  }
  const applyFilter = async () => {
    setFilterApplyStatus(true);
    setAllApiData([]);
    let updatefilter = {
      ...listFilter,
      page_type: selectedTab,
      log_id: user.userid,
      studentateOptionsselect:studentDateOption,
      dateRangeValue:`${format(dateRangeValue[0].startDate, "dd-MM-yyyy")} | ${format(dateRangeValue[0].endDate, "dd-MM-yyyy")}`,
      dateRangeValuefilter: dateRangeValue,
      selectedCategory:selectedCategory,
      selectedClass:selectedClass,
    };
    
    setListFilter(updatefilter);
    setPageNum(1);
    closeFilter();
  }

  const updateSetListingFilter = async () => {
    let updatefilter = {
      ...initial_obj,
      page_type: selectedTab
    };
  
    setListFilter({ ...updatefilter });
  };

  const setLocalStorage = async () =>  {
    var getoldfilter = localStorage.getItem("allfilterinventory");
    console.log("getoldfilter = ", getoldfilter);
    if (getoldfilter) {
      oldFilter = JSON.parse(getoldfilter);
      var currenttabfilter = oldFilter[selectedTab] ? oldFilter[selectedTab]:"";
      console.log("currenttabfilter = ", currenttabfilter);
      if (currenttabfilter) {
      } else {
        updateSetListingFilter();
      }
    } else {
      updateSetListingFilter();
    }
  }

   const clearFilter = () => {
    setFilterCount(0);
    FilterAllStateClear();
    let updatefilter = {
      ...listFilter,
      page_type: selectedTab,
      log_id: user.userid,
      studentateOptionsselect:"",
      dateRangeValue:"",
      dateRangeValuefilter: "",
      selectedCategory:[],
      selectedClass:[],
  
    };
    let getOldFilterclear = localStorage.getItem("allfilterinventory");
    let oldFilterValclear = getOldFilterclear
      ? JSON.parse(getOldFilterclear)
      : {};
    let currentTabFilterValclear = oldFilterValclear[selectedTab]
      ? { ...oldFilterValclear }
      : null;
    

    if(currentTabFilterValclear){
      delete currentTabFilterValclear[selectedTab];
      localStorage.setItem(
        "allfilterinventory",
        JSON.stringify(currentTabFilterValclear)
      );
    }
    getAllFilter();
    updateSetListingFilter();
    closeFilter();
    setFilterApplyStatus(false);
  };
  const FilterAllStateClear=()=>{
    setFilterStatus(0);
    setSelectedClass([]);
    setSelectedCategory([]);
    setStudentDateOption("");
    setStudentDateOptionLabel("Select Date");
    setDateRangeValue([
      {
        startDate: new Date(),
        endDate: addDays(new Date(), 0),
        key: "selection",
      },
    ]);
    setShowDateInput(false);

    setDateRangeValue([
      {
        startDate: new Date(),
        endDate: addDays(new Date(), 0),
        key: "selection",
      },
    ]);
    setShowFilterPopup(false);
    document.body.style.overflow = "auto";
  }
  useEffect(() => {
    let allLogs = [];
    Object.values(dummyLogs).forEach((logsArray) => {
      allLogs = allLogs.concat(logsArray);
    });
    setLogs(allLogs);
  }, []);

  const toggleDateRangeCalendar = () => {
    setShowDateRangeCalendar(!showDateRangeCalendar);
  };
  const handleDateRangeChange = (item) => {
    setDateRangeValue([item.selection]);
  };
  const handleClickOutside = (event) => {
    if (
      dateRangePickerRef.current &&
      !dateRangePickerRef.current.contains(event.target)
    ) {
      setShowDateRangePicker(false);
      setShowDateRangeCalendar(false);
    }
  };

  useEffect(() => {
    if (showDateRangePicker || showDateRangeCalendar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDateRangePicker, showDateRangeCalendar]);

  const staticRanges = [
    {
      label: "Today",
      range: () => ({
        startDate: startOfToday(),
        endDate: new Date(),
      }),
      isSelected: () => {
        const { startDate, endDate } = staticRanges[0].range();
        if (dateTimeType === "Today") {
          return true;
        } else if (!dateTimeType) {
          if (dateRangeValue[0].startDate.getTime() === startDate.getTime()) {
            setDateTimeType("Today");
            return true;
          }
        }
        return false; // Explicitly return false if condition is not met
      },
    },
    {
      label: "Yesterday",
      range: () => ({
        startDate: startOfYesterday(),
        endDate: startOfYesterday(),
      }),
      isSelected: () => {
        const { startDate, endDate } = staticRanges[1].range();
        if (dateTimeType === "Yesterday") {
          return true;
        } else if (!dateTimeType) {
          if (
            dateRangeValue[0].startDate.getTime() === startDate.getTime() &&
            dateRangeValue[0].endDate.getTime() === endDate.getTime()
          ) {
            setDateTimeType("Yesterday");
            return true;
          }
        }
        return false;
      },
    },
    {
      label: "This Week",
      range: () => ({
        startDate: startOfWeek(new Date()),
        endDate: endOfWeek(new Date()),
      }),
      isSelected: () => {
        const { startDate, endDate } = staticRanges[2].range();
        if (dateTimeType === "This Week") {
          return true;
        } else if (!dateTimeType) {
          if (
            dateRangeValue[0].startDate.getTime() === startDate.getTime() &&
            dateRangeValue[0].endDate.getTime() === endDate.getTime()
          ) {
            setDateTimeType("This Week");
            return true;
          }
        }
        return false;
      },
    },
    {
      label: "Last Week",
      range: () => ({
        startDate: startOfWeek(subWeeks(new Date(), 1)),
        endDate: endOfWeek(subWeeks(new Date(), 1)),
      }),
      isSelected: () => {
        const { startDate, endDate } = staticRanges[3].range();
        if (dateTimeType === "Last Week") {
          return true;
        } else if (!dateTimeType) {
          if (
            dateRangeValue[0].startDate.getTime() === startDate.getTime() &&
            dateRangeValue[0].endDate.getTime() === endDate.getTime()
          ) {
            setDateTimeType("Last Week");
            return true;
          }
        }
        return false;
      },
    },
    {
      label: "This Month",
      range: () => ({
        startDate: startOfMonth(new Date()),
        endDate: endOfMonth(new Date()),
      }),
      isSelected: () => {
        const { startDate, endDate } = staticRanges[4].range();
        if (dateTimeType === "This Month") {
          return true;
        } else if (!dateTimeType) {
          if (
            dateRangeValue[0].startDate.getTime() === startDate.getTime() &&
            dateRangeValue[0].endDate.getTime() === endDate.getTime()
          ) {
            setDateTimeType("This Month");
            return true;
          }
        }
        return false;
      },
    },
    {
      label: "Last Month",
      range: () => ({
        startDate: startOfMonth(subMonths(new Date(), 1)),
        endDate: endOfMonth(subMonths(new Date(), 1)),
      }),
      isSelected: () => {
        const { startDate, endDate } = staticRanges[5].range();
        if (dateTimeType === "Last Month") {
          return true;
        } else if (!dateTimeType) {
          if (
            dateRangeValue[0].startDate.getTime() === startDate.getTime() &&
            dateRangeValue[0].endDate.getTime() === endDate.getTime()
          ) {
            setDateTimeType("Last Month");
            return true;
          }
        }
        return false;
      },
    },
    {
      label: "All Time",
      range: () => ({
        startDate: new Date(2021, 0, 1),
        endDate: new Date(),
      }),
      hasCustomRendering: true,
      isSelected: () => {
        const { startDate, endDate } = staticRanges[6].range();
        if (dateTimeType === "All Time") {
          return true;
        } else if (!dateTimeType) {
          if (dateRangeValue[0].startDate.getTime() === startDate.getTime()) {
            setDateTimeType("All Time");
            return true;
          }
        }
        return false;
      },
    },
    {
      label: "Custom",
      range: () => ({
        startDate: new Date(),
        endDate: new Date(),
      }),
      hasCustomRendering: true,
      isSelected: () => {
        const { startDate, endDate } = staticRanges[7].range();
        if (dateTimeType === "Custom") {
          return true;
        } else if (!dateTimeType) {
          if (
            dateRangeValue[0].startDate.getTime() &&
            dateRangeValue[0].endDate.getTime()
          ) {
            setDateTimeType("Custom");
            return true;
          }
        }
        return false;
      },
    },
  ];
  const selectRange = () => {
    for (let i = 0; i < staticRanges.length; i++) {
      if (staticRanges[i].isSelected()) {
        // Once a match is found, exit the loop
        break; // Exit the loop after the first successful match
      }
    }
  };

  // Call the function to start the check
  selectRange();
  const staticRangesWithToggle = [
    ...staticRanges,
  ];

  const getAllFilter = async () => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/log_list.php?fun=getallfilter`,
      headers: { "Auth-Id": user.auth_id },
      data: {},
    }).then(function (response) {
      {/*checkUserLogin(response);*/}
      if (response.data.data.status === "1") {
        const filterList = response.data.data.data;
        setAllApiFilter(filterList);
        setClassListOptions(filterList.uasClassOptions);
        setCategoryListOptions(filterList.categoryOptions);
        setStudentDateListOptions(filterList.studentDateListOptions);
        setFilterApiStatus(true);
      }
    })
    .catch(function (error) {
      console.error("Error during login:", error);
    });
  };
  const checkUserLogin = (response) => {
    if (response.data.login.status === 0) {
      dispatch(logout());
      navigate("/login");
    }
  };
  useEffect(()=>{
    if(listFilter.page_type==selectedTab){
      getAllFilter();
    }
  },[selectedTab,listFilter]);

  useEffect(()=>{
    FilterAllStateClear();
    setLocalStorage();
  },[selectedTab]);
  useEffect(()=>{
    getUserWorkOrderStatus();
  },[selectedTab]);
  const getUserWorkOrderStatus = async () => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/log_list.php?fun=getUserWorkOrderStatus`,
      headers: { "Auth-Id": user.auth_id },
      data: { page_num: pageNum, limit: limit, filter: listFilter },
    }).then(function (response) {
      checkUserLogin(response);
      if (response.data.data.status === "1") {
        setCheckWorkOrderStatus(response.data.data.workorder_status);
      }
    })
    .catch(function (error) {
      console.error("Error during login:", error);
    });
  }
  const getStudentListRecord = async () => {
    
    setAutoLoader(true);
    setDisplayMsg("");
    axios({
      method: "post",
      url: `${constant.base_url}/student/log_list.php?fun=getStudentListRecord`,
      headers: { "Auth-Id": user.auth_id },
      data: { page_num: pageNum, limit: limit, filter: listFilter },
    }).then(function (response) {
      checkUserLogin(response);
        if (response.data.data.status === "1") {
          if (pageNum === 1) {
            setAllApiData(response.data.data);
            setTotalPageNum(response.data.data.total_page);
            setTotalFlyingCount(response.data.data.total_flying_time);
            setTotalCount(response.data.data.total_count);
            setRecordList([...response.data.data.list]);
          } else {
            setRecordList([...recordList, ...response.data.data.list]);
          }
          setPageNum((prevPageNum) => prevPageNum + 1);
          setDataStatus(true);
        } else {
          setTotalCount(0);
          setTotalFlyingCount("00:00");
	        setRecordList([]);
          setDisplayMsg(response.data.data.msg);
        }
        setFilterStatus(response.data.data.filter_status);
        setAutoLoader(false);
        setIsFetching(false);
        setDataStatus(true);
    })
    .catch(function (error) {
      console.error("Error during login:", error);
    });
  };
  useEffect(() => {
    if(filterApiStatus && listFilter.page_type==selectedTab){
      getStudentListRecord();
    }
  }, [selectedTab,filterApiStatus,listFilter]);
  
  useEffect(() => {
    const scrollHandler = () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const { scrollHeight, scrollTop, clientHeight } =
          document.documentElement;
        if (scrollTop + clientHeight >= scrollHeight - 70 && !isFetching) {
          setIsFetching(true);
          if (pageNum <= totalPageNum) {
            getStudentListRecord();
          }
        }
      }, 200); // Adjust the debounce delay as needed
    };

    let scrollTimeout;

    window.addEventListener("scroll", scrollHandler);

    return () => window.removeEventListener("scroll", scrollHandler);
  }, [isFetching, pageNum]);

  //LOG PDF
  const handleStudentLogsPDF = (studentid)=>{
    handleShowMonthAccordingData(studentid);
  }
  const handleSelectedMonth = (option) => {
    setLogSelectedMonth(option);
  };
  const cancelDroneSelectPopup = () => {
    setShowLogMontlyData(false);
  }

  const handleShowMonthAccordingData = (studentid) => {
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_log_pdf_gen.php?fun=showLogMonthAccordingData`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        type: "student_log",
        filter: listFilter,
        ...(studentid && { studentid })
      },
    })
      .then(function (response) {
        checkUserLogin(response);
        if (response.data.data.status === "1" && response.data.data.dropdown_status === "1" ) {
          setShowLogMontlyData(true);
          setShowCalendarData(response.data.data.calendar_data);
        } else if(response.data.data.status === "1" && response.data.data.dropdown_status === "0") {
          handleDownloadStudentPDF(response.data.data.calendar_data[1],0);
        }
      })
      .catch(function (error) {
        console.error("Error fetching drone log month data:", error);
      });
  };
  const handleDownloadClick = () => {
    if (
      !logSelectedMonth ||
      Object.keys(logSelectedMonth).length === 0 || 
      !logSelectedMonth.value ||
      logSelectedMonth.value.trim() === ""
    ) {
      toast.warning("Please select a month before downloading the PDF.");
      return;
    }

    handleDownloadStudentPDF(logSelectedMonth,1);
  };
  const handleDownloadStudentPDF = (selectedmonth = null,selectedMonthStatus) => {
    setUpdateBtnStatus(true);
    axios({
      method: "post",
      url: `${constant.base_url}/student/student_log_pdf_gen.php?fun=downloadstudentpdf`,
      headers: { "Auth-Id": user.auth_id },
      data: {
        filter: listFilter,
        ...(selectedmonth && { selectedmonth }),
        selectedMonthStatus:selectedMonthStatus
      },
    }).then(async function (response) {
      checkUserLogin(response);
        const resData = response.data.data;
      if (resData.status === "1") {
        //window.open(response.data.data.pdf_link, '_blank');
        const response = await fetch(resData.pdf_link);
            if (!response.ok) {
                console.error('Network response was not ok.');
                return;
              }
              const blob = await response.blob();
              const url = window.URL.createObjectURL(blob);
              const urlParts = response.url.split('/');
              const filename = urlParts[urlParts.length - 1] || 'download.pdf';

              const anchor = document.createElement('a');
              anchor.href = url;
              anchor.download = filename;
              document.body.appendChild(anchor);
              anchor.click();
              document.body.removeChild(anchor);
              window.URL.revokeObjectURL(url); 
            setUpdateBtnStatus(false);
      }
    })
    .catch(function (error) {
      console.error("Error during login:", error);
    });
  } 

  const handleBillingPage = () => {
    navigate("/my-account?tab=billing");
  }
  return (
    <>
      <InnerHeader
        heading={
          user.user_name
            ? `${user.user_name}'s Flying Logs`
            : "Student Flying Logs"
        }
        txtSubHeading="View and manage the list of students. Keep track of their progress, attendance, and other important details."
        showButton={false}
      />
      <Card className="bg1 mt16 p12">
        {checkWorkOrderStatus ? (
          <>
            <div className="v-center jcsb">
              <div className="v-center filter-lists" style={{ gap: "8px" }}>
                <div className="mr8 plan-status mb8">
                  <Dropdown
                    label={studentDateOptionLabel}
                    options={studentDateListOptions}
                    selectedValue={studentDateOption}
                    onValueChange={handleStudentDateOptionChange}
                  />
                </div>
                <div
                  className={`report-date mb8 ${showDateInput ? "mr8" : ""}`}
                >
                  {showDateInput && dateRangeValue && (
                    <div
                      onClick={toggleDateRangeCalendar}
                      className="date-range-input"
                      style={{
                        cursor: "pointer",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#7b7b7b",
                        fontSize: "14px",
                      }}
                    >
                      {`${format(
                        dateRangeValue[0].startDate,
                        "dd/MM/yyyy"
                      )} - ${format(dateRangeValue[0].endDate, "dd/MM/yyyy")}`}
                    </div>
                  )}
                  {showDateRangeCalendar && (
                    <div ref={dateRangePickerRef}>
                      <DateRangePicker
                        onChange={handleDateRangeChange}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        months={2}
                        ranges={dateRangeValue}
                        direction="horizontal"
                        staticRanges={staticRangesWithToggle}
                        renderStaticRangeLabel={(range) => (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <span style={{ marginRight: "4px" }}>{range.label}</span>
                          </div>
                        )}
                      />
                    </div>
                  )}
                </div>
                <div className="form-group-settings mr8 cm-fr searching-drop mb4 st-cr">
                  <MultiDropdown
                    label="Class List"
                    options={classListOptions}
                    selectedValues={selectedClass}
                    onSelect={handleSelectClass}
                    searchable
                    chips={1}
                    onAddNewOption={false}
                  />
                </div>
                {/* <FaFilter
                  className="cp fs16 mb8 ml12 fc6"
                  onClick={handleFilterClick}
                /> */}
                <button 
                  className="bg3 fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 mr8"
                  onClick={applyFilter}
                >
                  Apply
                </button>
                {filterStatus > 0 && <button
                  className="clear fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 fw6"
                  onClick={clearFilter}
                >
                  Clear
                </button>}
              </div>
              {/*showFilterPopup && (
                <SidePopup show={showFilterPopup} onClose={closeFilter}>
                  <div className="df jcsb brd-b1 p12 box-center bg7 w100 fc1 ls2 lh22">
                    <p className="fs18 fc1 ">Filters</p>
                    <button className="lead-close-button" onClick={closeFilter}>
                      X
                    </button>
                  </div>
                  <div className="filter-lists pl16 pt16 pr16">
                    <div className="status-filter mb12">
                      <p className="fc15 fw6 fs14 ls1 mb8">Category</p>
                      <MultiDropdown
                        label="Category"
                        options={categoryListOptions}
                        selectedValues={selectedCategory}
                        onSelect={handleSelectCategory}
                        chips={1}
                      />
                    </div>
                  </div>
                  <div className="filter-button-container mt16 pt16 box-center myteam-filters ">
                    <button
                      type="button"
                      className="bg3 fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 mr8"
                      onClick={closeFilter}
                    >
                      Close
                    </button>
                    <button 
                      className="bg3 fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 mr8"
                      onClick={applyFilter}
                    >
                      Apply
                    </button>
                    {filterStatus > 0 && <button
                      className="clear fs12 pl12 pr12 pt8 pb8 fc1 cp br16 ls1 fw6 cp"
                      onClick={clearFilter}
                    >
                      Clear
                    </button>}
                  </div>
                </SidePopup>
              )*/}
              {totalCount > 0 ? (
              <div className="v-center" style={{ gap: "12px" }}>
                <button 
                  className={`bg1 br24 fs14 cp pl16 pr16 pt10 pb10 ls1 flex ai-center gap8 ${
                      updateBtnStatus ? "disabled-input" : "btn-blue"
                  }`}
                  disabled={updateBtnStatus}
                  onClick={() => {
                    if (!updateBtnStatus) {
                      handleStudentLogsPDF(user.userid);
                    }
                  }}
                >
                  <FaCloudDownloadAlt className="mr4"  style={{ verticalAlign: "middle" }} />
                  Download PDF
                </button>
                
              </div>
              ) : ("")}
            </div>
            <Card className="bg1 mt16 pb16">
              <div className="mylead-filters v-center jcsb pl16 pr16 brd-b1 pb8 pt8 fww fs12">
                <p className="fs14 fw5">
                  Total Records: {totalCount} | 
                  Total Flying Hours: {totalFlyingCount}
                </p>
              </div>
              <div>
                <div
                  className="booked table-container df w100 fdc mt16"
                  style={{ overflow: "auto" }}
                >
                  <table className="mylead-table student-log-table cp wsnw">
                    <thead className="w100">
                      <tr>
                        {/* <th style={{padding: '5px'}} rowSpan={2}>S.No.</th> */}
                        <th style={{padding: '5px'}} rowSpan={2}>Date</th>
                        <th style={{padding: '5px'}} colSpan={3}>UAS Details</th>
                        <th style={{padding: '5px'}} rowSpan={2}>Name of RPIC<br /> /RPA Trainer</th>
                        <th style={{padding: '5px'}} rowSpan={2}>Name of Remote Pilot<br /> /RPA Trainee</th>
                        <th style={{padding: '5px'}} rowSpan={2}>Route of Flight <br/> /Place of Operation</th>
                        <th style={{padding: '5px'}} colSpan={2}>Time of Operation</th>
                        <th style={{padding: '5px'}} rowSpan={2}>Duration <br /> (HH:MM)</th>
                        <th style={{padding: '5px'}} colSpan={2}>Rotorcraft</th>
                        <th style={{padding: '5px'}} colSpan={2}>Aeroplane</th>
                        <th style={{padding: '5px'}} colSpan={2}>Hybrid/Other</th>
                        <th style={{padding: '5px'}} colSpan={3}>Operational Condition Time</th>
                        <th style={{padding: '5px'}} rowSpan={2}>Night</th>
                        <th style={{padding: '5px'}} rowSpan={2}>Instructional <br/> Hours</th>
                        <th style={{padding: '5px'}} rowSpan={2}>Exercise/Remarks<br />/Performance</th>
                      </tr>
                      <tr>
                        <th style={{padding: '5px'}}>UIN / DAN</th>
                        <th style={{padding: '5px'}}>Class</th>
                        <th style={{padding: '5px'}}>Category</th>
                        <th style={{padding: '5px'}}>Start (GMT)</th>
                        <th style={{padding: '5px'}}>End (GMT)</th>
                        <th style={{padding: '5px'}}>Dual</th>
                        <th style={{padding: '5px'}}>RPIC</th>
                        <th style={{padding: '5px'}}>Dual</th>
                        <th style={{padding: '5px'}}>RPIC</th>
                        <th style={{padding: '5px'}}>Dual</th>
                        <th style={{padding: '5px'}}>RPIC</th>
                        <th style={{padding: '5px'}}>Basic</th>
                        <th style={{padding: '5px'}}>Special</th>
                        <th style={{padding: '5px'}}>Advanced</th>
                      </tr>
                    </thead>
                    <tbody>
                      {recordList.length > 0 ? (
                        recordList.map((log, index) => (
                          <tr key={index}>
                            <td>{log.createDate}</td>
                            <td>{log.drone_id}</td>
                            <td>
                              <DynamicTooltip direction="left" text={log.full_class}>{log.class}</DynamicTooltip>
                            </td>
                            <td>
                              <DynamicTooltip direction="left" text={log.full_category}>{log.category}</DynamicTooltip>
                            </td>
                            <td>
                              <DynamicTooltip direction="left" text={log.full_name_of_rpic}>
                                {log.name_of_rpic && log.name_of_rpic.length > 10 ? log.name_of_rpic.slice(0, 10) + '...' : log.name_of_rpic}
                              </DynamicTooltip>
                            </td>
                            <td>
                              <DynamicTooltip direction="left" text={log.student}>
                                {log.student && log.student.length > 10 ? log.student.slice(0, 10) + '...' : log.student}
                              </DynamicTooltip>
                            </td>
                            <td>{log.rpto}</td>
                            <td>{log.startTime}</td>
                            <td>{log.endTime}</td>
                            <td>{log.duration}</td>
                            <td>{log.rotoarcraft_dual}</td>
                            <td>{log.rotoarcraft_rpic}</td>
                            <td>{log.aeroplane_dual}</td>
                            <td>{log.aeroplane_rpic}</td>
                            <td>{log.other_dual}</td>
                            <td>{log.other_rpic}</td>
                            <td>{log.basic}</td>
                            <td>{log.speical}</td>
                            <td>{log.advanced}</td>
                            <td>{log.night}</td>
                            <td>{log.instructional_hours}</td>
                            <td className="feedback-inquiry scrollable-cell"><p>{log.remarks}</p></td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="24" className="tac">No logs found.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Card>
          </>
        ) : (
          <>
            <img src={PayDue} className="no-data-img" alt="No data"/>
            <p className="fs16 fc8 tac">Please clear all outstanding <span onClick={handleBillingPage} className="cp fc3 tdu">Payments</span> to continue.</p>
          </>
        )}
      </Card>
      {showDroneLogMontlyData && (
        <div className="log-popup">
          <Popup title="" onClose={cancelDroneSelectPopup}>
            <p className="ls1 lh22 fs16 mb24 tac">
              Select the Month
            </p>
            <div className="batch-options">
              <SingleDropdown
                label="Select Month"
                options={showCalendarData}
                selectedOption={logSelectedMonth}
                onSelect={handleSelectedMonth}
                compulsory={<span className="fc4">*</span>}
              />
            </div>
            <div className="popup-buttons mb24 df jcc">
              
               <button onClick={()=>{if (!updateBtnStatus) {handleDownloadClick()}}}  className={`update-button box-center mr24  ${updateBtnStatus ? 'disabled-input' : 'btn-blue'}`}>
                Download PDF
              </button>
              <button onClick={cancelDroneSelectPopup} className="btn-cancel">
                Cancel
              </button>
            </div>
          </Popup>
        </div>
      )}
      <ToastContainer position="bottom-right" />
    </>
  );
};

export default MainLog;